// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__Judpo","label":"Category_label__1HZ_K","content":"Category_content__39Y55","header":"Category_header__2jV2c","location":"Category_location__cMew6"};